module.exports = __webpack_public_path__ + "img/wxfh_n.32719a29.png";